/**
 * Раскладка каркаса окна сущности на узком экране.
 *
 * Ниже ~960 px окно занимает весь экран с отступом 8 px, колонка (фото, цифры,
 * идентификаторы) уходит над вкладки, а тело скроллится целиком. Каркас узнаёт
 * ширину через matchMedia и сообщает её содержимому контекстом: колонке нужен
 * компактный вид, полосе «Что дальше» — перенос кнопок под вывод.
 * Вне каркаса (контекст не задан) раскладка всегда широкая.
 */

import { createContext, useContext, useEffect, useState } from 'react'

/** Граница узкой раскладки: 959 px включительно — узкая, от 960 px — как прежде. */
export const NARROW_QUERY = '(max-width: 959px)'

export interface EntityShellLayout {
  narrow: boolean
}

export const EntityShellLayoutContext = createContext<EntityShellLayout>({ narrow: false })

export const useEntityShellLayout = (): EntityShellLayout => useContext(EntityShellLayoutContext)

const canMatch = (): boolean => typeof window !== 'undefined' && typeof window.matchMedia === 'function'

/** Узкий ли экран сейчас. Без matchMedia (старая среда) — широкий. */
export function useNarrowScreen(): boolean {
  const read = () => (canMatch() ? Boolean(window.matchMedia(NARROW_QUERY)?.matches) : false)
  const [narrow, setNarrow] = useState(read)
  useEffect(() => {
    if (!canMatch()) return undefined
    const media = window.matchMedia(NARROW_QUERY)
    if (!media) return undefined
    const onChange = () => setNarrow(Boolean(media.matches))
    onChange()
    media.addEventListener?.('change', onChange)
    return () => media.removeEventListener?.('change', onChange)
  }, [])
  return narrow
}
